export default __webpack_public_path__ + "static/bg-blood-844296c9f9ae84042a3a3f0d12ea1e14.jpg";